const OperationTypeSending = {
  Buy: false,
  ReceivedFromOuter: false,
  SentOut: true,
  Sell: true,
};

export default OperationTypeSending;
